import { Component, Inject, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApplicationFacade } from '@ridango/components';
import { DisruptionMessage, DisruptionMessageSeverity } from '@ridango/core';
import { DisruptionMessageDetailsComponent } from '../containers/journey-planner/disruption-message-details/disruption-message-details.component';
import Env from '@ridango/core/env';

enum messageTypes {
    warning = 'warning',
    cancelled = 'cancelled',
    info = 'info'
}

@Component({
    selector: 'rwidget-caption',
    templateUrl: './caption.component.html',
    styleUrls: ['./caption.component.scss']
})
export class CaptionComponent {
    @Input() disruptionMessage: DisruptionMessage;
    DisruptionMessageSeverity = DisruptionMessageSeverity;
    messageTypes = messageTypes;
    messageType: messageTypes = messageTypes.warning;
    assetsPath$ = this.applicationFacade.assetsPath$;
    constructor(
        protected applicationFacade: ApplicationFacade,
        private modalCtrl: ModalController,
        @Inject('ENV') public env: Env
    ) {}

    async openDisruptionMessageDetailsView(message: DisruptionMessage | any) {
        const modal = await this.modalCtrl.create({
            component: DisruptionMessageDetailsComponent,
            componentProps: {
                disruptionMessage: message
            }
        });

        modal.componentProps = {
            ...modal.componentProps,
            modalRef: modal
        };

        await modal.present();
    }
}
